import "./NFTab.css";

interface IProps {
  title: string;
  active?: boolean;
  onTabClick?: () => void;
}

export const NFTab = ({ title, onTabClick, active }: IProps) => {
  return (
    <>
      <button
        onClick={onTabClick}
        className={`btn ${active === true ? "custom-btn" : "btn-light"}`}
      >
        {title}
      </button>
    </>
  );
};
